import type { AbsenceDateElement } from 'shared/graphql/graphql'

// This cleans the __typename to send it back. Also the type that is free by default on creation
export const getTaskDatesInitialData = (taskDates: AbsenceDateElement[]) =>
  taskDates.map((item) => ({
    date: item.date ?? '',
    period: item.period ?? '',
    type: '',
  }))
